<template>
  <v-container  class="grey lighten-5 mt-5" xs="12" v-if="validNews == true">
    <ReportDialog ref="reportDialog"></ReportDialog>
    <CommentDialog ref="commentDialog"></CommentDialog>

    <!--Dialog when share button is clicked-->
    <v-dialog v-model="shareDialog" max-width="600px" class="ma-0">
      <v-card>
        <v-row class="ma-0 pa-0 exitShare">
          <v-btn icon @click="shareDialog = false">
            <v-icon small>fas fa-times</v-icon>
          </v-btn>
        </v-row>

        <v-list>
          <v-list-item>
            <v-text-field
              class="ma-5 pa-5"
              readonly
              color="primary"
              v-model="shareURL"
              ref="getShareURL"
              type="text"
              auto-grow
              single-line
              full-width
            >
              <template v-slot:append>
                <v-btn tile color="primary" text class="ma-0" @click="copy">copy</v-btn>
              </template>
            </v-text-field>
          </v-list-item>
        </v-list>
      </v-card>
    </v-dialog>

    <!--Module title-->
    <h2 class>
      <span class="techCol">|</span>
      {{$t("Technology")}}
    </h2>

    <v-row height="100%">
      <!--The Main TECH article (bigger picture than rest)-->
      <v-col class="mainCol" v-for="card in main" :key="card.id" cols="12" lg="6" md="6" sm="12">
        <v-row>
          <v-col>
            <v-card class="pa-2 noBorder d-flex flex-column" id="mainCard" outlined flat tile>
              <v-card-actions>
                <v-card-text justify="start" class="pa-2">
                  <span class="authorText">{{card.NickName}}</span> |
                  <span class="dateText">{{card.Date}}</span>
                </v-card-text>
                <v-menu offset-y left>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon class="cardIcon" v-bind="attrs" v-on="on">
                      <v-icon small>fas fa-ellipsis-h</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item @click="bookmark()">
                      <v-list-item-title>
                        <v-btn icon class="cardIcon">
                          <v-icon small>far fa-bookmark</v-icon>
                        </v-btn>
                        {{$t("Bookmark article")}}
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      @click.stop="
                $refs.reportDialog.openDialog({
                  reportedId: card.id,
                  reportType: 'article',
                  content: card.Title
                })
              "
                    >
                      <v-list-item-title>
                        <v-btn icon class="cardIcon">
                          <v-icon small>fas fa-exclamation-triangle</v-icon>
                        </v-btn>
                        {{$t("Report")}}
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-card-actions>

              <v-card
                class="noBorder"
                outlined
                flat
                tile
                :to="{
                name: `frontpage`,
                params: { articleid: card.id },
              }"
              >
                <v-img
                  v-if="card.MediaData && card.MediaData.length > 0"
                  :src="`${card.MediaData[0]['s3url']}-web.jpg`"
                  class="mainCatimg"
                  cover
                >
                  <div class="imgDiv">{{$t("Technology")}}</div>
                </v-img>
                <v-img v-else :src="`/lrVxWoHA.png`" class="mainCatimg" contain>
                  <div class="imgDiv">{{$t("Technology")}}</div>
                </v-img>

                <h2 class="pa-2 mainCardTitle">{{card.Title}}</h2>
                <div
                  class="body-1"
                  style="display: -webkit-box; -webkit-line-clamp: 3; -webkit-box-orient: vertical; overflow: hidden;"
                  v-html="card.Content"
                />
              </v-card>

              <v-spacer></v-spacer>
              <v-card-actions class="pa-0 align-end" justify="center" align="center">
                <v-col>
                  <v-btn icon small class="cardIcon">
                    <v-icon small>fas fa-book-reader</v-icon>
                    <span class="metaCount">{{card.Views}}</span>
                  </v-btn>
                </v-col>

                <v-col>
                  <v-btn icon small class="cardIcon">
                    <v-icon small>far fa-comment-alt</v-icon>
                    <span class="metaCount">{{card.Comments}}</span>
                  </v-btn>
                </v-col>

                <v-col>
                  <v-btn icon small class="cardIcon" @click="share(card.id)">
                    <v-icon small>fas fa-share-alt</v-icon>
                    {{$t("Share")}}
                  </v-btn>
                </v-col>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-col>

      <!-- Medium sized TECH articles-->
      <v-col cols="12" lg="6" md="6" sm="12" xs="12">
        <v-row>
          <v-col
            class="middleCol"
            v-for="card in middle"
            :key="card.id"
            cols="6"
            lg="6"
            md="6"
            sm="6"
            xs="6"
          >
            <v-card
              class="pa-1 ma-0 noBorder d-flex flex-column middleCard"
              outlined
              flat
              tile
              height="100%"
            >
              <v-card-actions class="pa-0 ma-0">
                <v-card-text justify="start" class="pa-2">
                  <span class="authorText pa-0">{{card.NickName}}</span> |
                  <span
                    class="dateText"
                    :style="$vuetify.breakpoint.smAndDown?'display:block':''"
                  >{{card.Date}}</span>
                </v-card-text>

                <v-menu offset-y left>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon class="cardIcon" v-bind="attrs" v-on="on">
                      <v-icon small>fas fa-ellipsis-h</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item @click="bookmark()">
                      <v-list-item-title>
                        <v-btn icon class="cardIcon">
                          <v-icon small>far fa-bookmark</v-icon>
                        </v-btn>
                        {{$t("Bookmark article")}}
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      @click.stop="
                $refs.reportDialog.openDialog({
                  reportedId: card.id,
                  reportType: 'article',
                  content: card.Title
                })
              "
                    >
                      <v-list-item-title>
                        <v-btn icon class="cardIcon">
                          <v-icon small>fas fa-exclamation-triangle</v-icon>
                        </v-btn>
                        {{$t("Report")}}
                      </v-list-item-title>
                    </v-list-item>

                    <v-list-item @click="share(card.id)">
                      <v-list-item-title>
                        <v-btn icon small class="cardIcon">
                          <v-icon small>fas fa-share-alt</v-icon>
                        </v-btn>
                        {{$t("Share")}}
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-card-actions>

              <v-card
                class="noBorder"
                outlined
                flat
                tile
                :to="{
                name: `frontpage`,
                params: { articleid: card.id },
              }"
              >
                <v-img
                  v-if="card.MediaData && card.MediaData.length > 0"
                  :src="`${card.MediaData[0]['s3url']}-web.jpg`"
                  class="middleCatimg"
                  cover
                >
                  <div class="imgDiv">{{$t("Technology")}}</div>
                </v-img>
                <v-img v-else :src="`/lrVxWoHA.png`" class="middleCatimg" contain>
                  <div class="imgDiv">{{$t("Technology")}}</div>
                </v-img>

                <h2 class="pa-2 middleCardTitle">{{card.Title}}</h2>
              </v-card>

              <v-spacer></v-spacer>
              <v-card-actions class="pa-0 align-end" justify="center" align="center">
                <v-col>
                  <v-btn icon small class="cardIcon">
                    <v-icon small>fas fa-book-reader</v-icon>
                    <span class="metaCount">{{card.Views}}</span>
                  </v-btn>
                </v-col>

                <v-col>
                  <v-btn
                    icon
                    small
                    class="cardIcon"
                    @click.stop="
                        $refs.commentDialog.openDialog({
                          Content: '',
                          Articles_id: card.id,
                          ArticleComments_id: card.id
                        })
                      "
                  >
                    <v-icon small>far fa-comment-alt</v-icon>
                    <span class="metaCount">{{card.Comments}}</span>
                  </v-btn>
                </v-col>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <!-- Small TECH articles -->
    <v-row>
      <v-col cols="12" class="pa-0">
        <v-row class="pa-0 ma-0">
          <v-col
            class="smallCol"
            v-for="card in small"
            :key="card.id"
            :cols="12"
            lg="4"
            md="4"
            sm="12"
            xs="12"
          >
            <v-card
              class="pl-2 pr-2 pt-2 pb-0 noBorder d-flex flex-column"
              height="100%"
              outlined
              flat
              tile
            >
              <v-card-actions class="pa-0 ma-0">
                <v-card-text justify="start" class="pa-2">
                  <span class="authorText pa-0">{{card.NickName}}</span>
                  |
                  <span
                    class="dateText"
                    :style="$vuetify.breakpoint.smAndDown?'display:block':''"
                  >{{card.Date}}</span>
                </v-card-text>

                <v-menu offset-y left>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon class="cardIcon" v-bind="attrs" v-on="on">
                      <v-icon small>fas fa-ellipsis-h</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item @click="bookmark()">
                      <v-list-item-title>
                        <v-btn icon class="cardIcon">
                          <v-icon small>far fa-bookmark</v-icon>
                        </v-btn>
                        {{$t("Bookmark article")}}
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      @click.stop="
                $refs.reportDialog.openDialog({
                  reportedId: card.id,
                  reportType: 'article',
                  content: card.Title
                })
              "
                    >
                      <v-list-item-title>
                        <v-btn icon class="cardIcon">
                          <v-icon small>fas fa-exclamation-triangle</v-icon>
                        </v-btn>
                        {{$t("Report")}}
                      </v-list-item-title>
                    </v-list-item>

                    <v-list-item @click="share(card.id)">
                      <v-list-item-title>
                        <v-btn icon small class="cardIcon">
                          <v-icon small>fas fa-share-alt</v-icon>
                        </v-btn>
                        {{$t("Share")}}
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-card-actions>

              <v-card
                class="noBorder mt-0 pt-0"
                outlined
                flat
                tile
                :to="{
                name: `frontpage`,
                params: { articleid: card.id },
              }"
              >
                <v-row class="ma-0 pa-0">
                  <v-col class="ma-0 pl-2 pr-1 pt-0 pb-0">
                    <p
                      class="font-weight-bold subtitle-2 pt-1 mb-0 pb-1"
                      style="display: -webkit-box; -webkit-line-clamp: 1; -webkit-box-orient: vertical; overflow: hidden;"
                      v-html="card.Title"
                    ></p>
                  </v-col>
                </v-row>

                <v-row class="ma-0 pa-0">
                  <v-col class="ma-0 pa-0 pa-2 d-flex">
                    <v-img
                      v-if="
                      card.MediaData &&
                      card.MediaData.length > 0
                                  "
                      class="mr-3 smallCatimg"
                      :src="`${card.MediaData[0]['s3url']}-web.jpg`"
                    ></v-img>
                    <div
                      class="body-1"
                      style="display: -webkit-box; -webkit-line-clamp: 3; -webkit-box-orient: vertical; overflow: hidden;"
                      v-html="card.Content"
                    />
                  </v-col>
                </v-row>
              </v-card>

              <v-spacer></v-spacer>
              <v-card-actions class="pa-0 align-end" justify="center" align="center">
                <v-col>
                  <v-btn icon small class="cardIcon">
                    <v-icon small>fas fa-book-reader</v-icon>
                    <span class="metaCount">{{card.Views}}</span>
                  </v-btn>
                </v-col>

                <v-col>
                  <v-btn
                    icon
                    small
                    class="cardIcon"
                    @click.stop="
                        $refs.commentDialog.openDialog({
                          Content: '',
                          Articles_id: card.id,
                          ArticleComments_id: card.id
                        })
                      "
                  >
                    <v-icon small>far fa-comment-alt</v-icon>
                    <span class="metaCount">{{card.Comments}}</span>
                  </v-btn>
                </v-col>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <div class="text-center">
      <v-btn class="ma-2" id="readMore" outlined color="#02577a" @click="loadSmall()">{{$t("read more")}}</v-btn>
    </div>
  </v-container>
</template>

<script>
/*
How this script works:

1. FrontPageLayout.vue sends a list of relevant tech news to store.js (techNews list)
2. Whenever techNews is updated in store, the getTechNews Watch function here triggers change
3. update() looks at techNews and decides where to place the content. Ex. Dont use a card
   with image if the MediaData list is empty etc. We have main, middle and small tech cards,
   but this is flexible and can be edited at any times
*/

import { mapGetters, mapActions } from "vuex";
import messages from "../../modules/lang/main/export";
import ReportDialog from "@/components/dialogs/report_dialog.vue";
import CommentDialog from "@/components/dialogs/kommentar_dialog.vue";
export default {
  i18n: { messages },

  components: {
    ReportDialog,
    CommentDialog,
  },

  data() {
    return {
      main: [],
      middle: [],
      small: [],
      buffer: [], //Internal load more button for tech news (loads small articles)
      validNews: false, //Activate only if we have enough tech news (else whole container is hidden)
      shareDialog: false,
      shareURL: window.location.href,
    };
  },

  computed: {
    ...mapGetters(["getTechNews"]),
  },

  watch: {
    getTechNews(data) {
      //Update cards when tech news is updated
      this.update(data);
    },
  },

  methods: {
    ...mapActions(["parseDate"]),

    async update(news) {
      /*
      Based on the list of tech news in store.js, 
      divide them into main, middle and small cards based on:

      1. MAIN: newest WePrezz, default: most read with image 
      2. MIDDLE: most read and most commented + 2 new articles with image
      3. SMALL: remaining articles sorted by date

    */


      let _main = [];
      let _rem = [];
      let WePrezzAlternative = false;
      let mostViewed = false;
      let mostCommented = false;

      //The news elements are allready sorted by date!
      await news.forEach((element) => {
        if (element.MediaData.length > 0) {
          if (element.NickName == "WePrezz" && _main.length == 0) {
            _main.push(element);
          } else if (mostViewed == false) {
            mostViewed = element;
          } else if (mostCommented == false) {
            mostCommented = element;
          } else if (element.Views > mostViewed.Views) {
            if (_main.length == 0 && WePrezzAlternative == false) {
              //Just an okay alternative if WePrezz has none
              WePrezzAlternative = element;
            } else if (mostViewed.Comments > mostCommented.Comments) {
              //The old most viewed has more comments than current most commented
              _rem.push(mostCommented);
              mostCommented = mostViewed;
              mostViewed = element;
            } else {
              _rem.push(mostViewed);
              mostViewed = element;
            }
          } else if (element.Comments > mostCommented.Comments) {
            _rem.push(mostCommented);
            mostCommented = element;
          } else {
            _rem.push(element);
          }
        } else {
          _rem.push(element);
        }
      });

      
      
      let _middle = []
        await _rem.forEach((el) => {
          if(el.MediaData.length > 0 && _middle.length < 2){
            _middle.push(el)
          }
        });

      //Ensure we have minimum amount of articles for this module
      if (
        (_main.length != 0 || WePrezzAlternative != false) &&
        mostCommented != false &&
        mostViewed != false &&
        _middle.length >= 2
      ) {
        if (_main.length == 0) {
          this.mainNews([WePrezzAlternative]);
          _main.push(WePrezzAlternative)
        } else {
          this.mainNews(_main);
        }
  
        let m = [mostViewed, mostCommented, _middle[0], _middle[1]]
        this.middleNews(m).then(
          () => {
            //Calculate height of main card when middle cards are inserted
            this.setMainCardHeigh();
          }
        );

        let _remove = [...m.map(x => x.id), ..._main.map(x => x.id)]
        _rem = _rem.filter(function( obj ) {
            return !_remove.includes(obj.id);
        });
        this.smallNews(_rem);
        this.validNews = true;
      } else {
        this.validNews = false;
      }
    },

    async mainNews(news) {
      //This is the biggest news card
      return new Promise(async (resolve, reject) => {
        for (const el of news) {
          el.subTitle = el.Content.substr(0, 240) + " ...";
          el.Date = await this.parseDate(el.Updated);
        }
        this.main = news;
        resolve();
      });
    },

    async middleNews(news) {
      //This is middle sized cards with just the header
      return new Promise(async (resolve, reject) => {
        for (const el of news) {
          el.Date = await this.parseDate(el.Updated);
        }
        this.middle = news;
        resolve();
      });
    },

    async smallNews(news) {
      //This is smaller news without image
      let _news = news; //display
      for (const el of _news) {
        el.Date = await this.parseDate(el.Updated);
      }
      this.buffer = _news; //Set in buffer by default. Load them if "read more" is clicked
    },

    loadSmall() {
      //Take 3 articles from buffer and show them for the user
      if (this.buffer.length && this.buffer.length >= 3) {
        this.small = [...this.small, ...this.buffer.slice(0, 3)];
        this.buffer = this.buffer.slice(3, this.buffer.length);
        if(this.buffer.length < 3){
          document.getElementById("readMore").style.display = "none"
        }
      }else{
          document.getElementById("readMore").style.display = "none"
      }
    },

    setMainCardHeigh() {
      //Set height of main card based on middle cards
      let height = document.getElementsByClassName("middleCard")[0]
        .clientHeight;
      document.getElementById("mainCard").style.height = 2 * height + 23 + "px";
    },

    bookmark() {
      //TODO
      console.log(this.state.publicpage.techNews);
    },
    share(id) {
      this.shareURL = location.origin + "/api/share/" + id;
      this.shareDialog = true; //Opens share dialog
    },
    copy() {
      let textInput = this.$refs.getShareURL.$el.querySelector("input");
      textInput.select();
      document.execCommand("copy");
    },
  },
};
</script>


<style scoped>
hr.hr1 {
  border: 1px solid black;
}

.cardIcon {
  margin: 0px 10px 0px 0px;
  opacity: 0.8;
}

.cardIconSmall {
  display: inline-block;
}

.noBorder {
  border: 0 !important;
}

.dateText {
  color: #666;
  font-size: 0.8em;
}

.authorText {
  font-weight: bold;
  font-size: 0.8em;
}

.metaCount {
  color: #ff5252;
  padding-left: 5px;
  font-size: 1.2em;
}

.mainCatimg {
  height: 320px !important;
}

.middleCatimg {
  height: 100px !important;
}

.smallCatimg {
  height: 75px !important;
  width: 75px !important;
}

.techCol {
  color: #02577a !important;
}

.middleCardTitle {
  height: 105px;
  overflow: hidden;
  font-size: 1.4em;
}

.mainCardTitle {
  font-size: 2em !important;
  max-height: 110px;
  overflow: hidden;
}

#mainCardSubtitle {
  font-size: 0.9em;
  color: #212121 !important;
  overflow: hidden;
  max-height: 160px !important;
}

.smallCardTitle {
  font-size: 1em;
  display: inline-block !important;
}

.smallCardSubtitle {
  padding: 0px;
}

.views {
  text-transform: lowercase !important;
  opacity: 1 !important;
  padding-left: px;
}

#shareDialog {
  max-width: 300px !important;
}
.exitShare {
  justify-content: end;
}

.imgDiv {
  font-size: 1em;
  color: white;
  justify-content: "end";
  background-color: #02577a;
  display: inline-block;
  padding: 0 8px;
  font-weight: 400;
  position: absolute;
  margin: 0;
  bottom: 0;
}

@media (max-width: 1264px) {
  .mainCatimg {
    height: 300px !important;
  }
}

@media (max-width: 960px) {
  .mainCatimg {
    height: auto !important;
    max-height: 450px !important;
  }

  #mainCard {
    height: auto !important;
    margin: 0;
    padding: 4px 2px 4px 2px;
  }

  .middleCatimg {
    height: 200px !important;
  }

  .middleCol {
    padding: 6px 3px 6px 3px;
  }

  .mainCol,
  .smallCol {
    margin: 0px;
    padding: 4px 2px 4px 2px;
  }
}

@media (max-width: 600px) {
  .middleCol {
    padding: 1.5px;
  }

  .middleCardTitle {
    max-height: 105px;
    font-size: 1em;
  }

  .middleCatimg {
    height: 100px !important;
  }

  .smallCatimg {
    height: 60px !important;
    width: 60px !important;
  }
}
</style>